import "assets/scss/pages/home.scss";

import { Box, Container, Grid, Stack } from "@mui/material";
import { Common, Custom, Item, Page, Tab, Workflow } from "components";
import { useApp, useService, useSession, useTheme } from "contexts";
import { IPotluck } from "interfaces";
import { Helpers } from "utils";
import { useEffect, useState } from "react";

type Props = {};

export const UserDashboard = (props: Props) => {
  const { theme } = useTheme();
  const { t } = useApp();
  const { potluckService } = useService();
  const { isAuthenticated, user } = useSession();

  const [potlucks, setPotlucks] = useState<IPotluck[]>([]);

  useEffect(() => {
    async function fetchData() {
      const response = await potluckService.mine(user.id);
      setPotlucks(
        response.filter(
          (item) => !user.settings.hiddenPotlucks.includes(item._id)
        )
      );
    }

    fetchData();
  }, []);

  const handleOnDelete = (id: string) =>
    setPotlucks(potlucks.filter((item) => item._id !== id));

  return (
    <Box py={theme.spacing.sm}>
      <Stack gap={theme.spacing.xxl}>
        <Container>
          {!isAuthenticated && (
            <Grid container>
              <Grid item xs={12} md={4}>
                <Common.Intro />
              </Grid>
              <Grid
                item
                xs={12}
                md={8}
                sx={{ display: { xs: "none", md: "unset" } }}
              >
                <Common.Image src={Helpers.getImage("homepage_art.png")} />
              </Grid>
            </Grid>
          )}
          {isAuthenticated && (
            <Grid container spacing={theme.spacing.xl}>
              <Grid item xs={12} md={8}>
                <Workflow.Flows.ProfileWrapper />
              </Grid>
              <Grid item xs={12} md={4}>
                <Common.Intro />
              </Grid>
            </Grid>
          )}
        </Container>
        <Container>
          <Grid container>
            <Grid item xs={12}>
              <Common.Header title={t.header.user_record} />
            </Grid>
            <Grid container spacing={theme.spacing.sm}>
              <Grid item xs={12}>
                <Tab.PotluckDashboard
                  potlucks={potlucks}
                  onDelete={handleOnDelete}
                />
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Stack>
    </Box>
  );
};
